import { PersonLink } from "./shared/facet/components/PersonFacet";
import { SpeciesLink } from "./makingsense/facet/components/SpeciesFacet";

export const DEFAULT_SECTION =
  process.env.REACT_APP_DEFAULT_SECTION || "makingsense";

// types listed will have a citation instruction panel
export const CITABLE_OBJECT_TYPES = [
  "image",
  "handwritten",
  "book_illustration"
];

export const OBJECT_PROPERTIES = [
  { key: "TITLE", label: "Title" },
  { key: "TITLE_SHOW", label: "Title" },
  { key: "CAPTION_EN", label: "Caption (EN)" },
  { key: "CAPTION_NL", label: "Caption (NL)" },
  { key: "DESCRIPTION", label: "Description" },
  { key: "PERSON_AUTHOR", label: "Author", render: PersonLink },
  { key: "LOCATION", label: "Location" },
  { key: "PLACE", label: "Location" },
  { key: "DATE", label: "Date" },
  { key: "DATE_ORIG", label: "Date" },
  { key: "SPECIES", label: "Species", render: SpeciesLink },
  { key: "LOCATION_IN_ARCHIVE", label: "Location in Archive" }
];

export const OBJECT_CTA_POSITION = "bottom";

export const HIM = {
  AAG: "Alciatus Collection Glasgow",
  BVH: "Bibliothèques Virtuelles Humanistes",
  BYVANCK: "Byvanck Genootschap",
  DMVI: "Mid-Victorian Illustration",
  EPU: "Utrecht Love Emblems",
  GEDP: "French Emblems Glasgow",
  GEP: "German Emblem Books",
  GUL: "Stirling Maxwell",
  HAB: "Herzog August Bibliothek",
  KBMSS: "KB Nederland Medieval Manuscripts",
  KB: "Koninklijk Bibliotheek Nederland",
  MILAN: "Marengo Satirical Journals",
  MMWMSS: "Museum Meermanno",
  MNE: "Arkyves Core Collections",
  MNE_DPD: "Arkyves Printer's Devices",
  MNE_EMB: "Arkyves Emblem Books",
  RIJKSMUSEUM: "Rijksmuseum",
  RKD: "Netherlands Institute for Art History",
  UIUC: "Emblem Books Illinois",
  URSICULA: "Typography",
  VKK: "Virtual Print Cabinet",
  FOLGER: "Folger Shakespeare Library",
  MSS: "Medieval Manuscripts",
  EMBLEMS: "Emblems",
  UVA: "Universiteit Amsterdam",
  LOC: "Library of Congress",
  BSB: "Bayerische Staatsbibliothek",
  FABLES: "Fables",
  ILL_BOOK: "Illustrated Books",
  DEVICES: "Printers Devices",
  ALC: "Alchemy",
  BIBLIASACRA: "Biblia Sacra",
  GPI: "Getty Provenance Index",
  CERL: "Consortium of European Research Libraries",
  TLC: "The Leiden Collection"
};

export const TYPES = {
  bibliography: "Bibliography",
  bibliographycontainer: "Bibliography Container",
  book: "Book",
  bookillustration: "Book Illustration",
  book_illustration: "Book Illustration",
  container: "Folder",
  emblempictura: "Emblem Pictura",
  emblembook: "Emblem Book",
  facsimile: "Facsimile",
  handwritten: "Handwritten",
  image: "Image",
  imagesfromperiodicals: "Periodical Image",
  manuscriptbook: "Manuscript",
  person: "Person",
  manuscriptillumination: "Manuscript Illumination",
  printersdevice: "Printers Device",
  printersdeviceusage: "Printers Device",
  proverb: "Proverb",
  typeface: "Typeface",
  ornament: "Ornament",
  initial: "Initial",
  titleprint: "Title Illustration",
  journal: "Journal",
  provenanceitem: "Provenance",
  provenancedocument: "Provenance",
  provenancesource: "Provenance Source",
  provenanceimage: "Provenance Image",
  essay: "Essay",
  diaries: { name: "Diaries", field: "TYPES" },
  notes: { name: "Notes", field: "TYPES" },
  correspondence: { name: "Correspondence", field: "TYPES" },
  location: { name: "Location", field: "TYPES" },
  species: { name: "Species", field: "TYPES" }
};

function facetsFromEnv() {
  //map book:Book,image:Drawing to {book: "Book", image: "Drawing"}
  const facets = process.env.REACT_APP_FACETS.split(",").map(v => v.split(":"));
  const out = {};
  for (const facet of facets) {
    out[facet[0]] = facet[1];
  }
  return out;
}

export default {
  TYPES,
  HIM,
  ICONCLASS_ENABLED: (process.env.REACT_APP_ICONCLASS_ENABLED || "1") === "1",
  FACETS: process.env.REACT_APP_FACETS && facetsFromEnv(),
  DEFAULT_SEARCH_LAYOUT:
    process.env.REACT_APP_DEFAULT_SEARCH_LAYOUT || "details",
  DEFAULT_SORT_ORDER: process.env.REACT_APP_DEFAULT_SORT_ORDER || "RANDOM"
};
